import { defaultBodySearchRequest } from '@vakantiesnl/services/src/search';
import { type Search } from '@vakantiesnl/types';

export const DEFAULT_DEALS_PAGE_SIZE = 4;
export const LIMITED_DEALS_PAGE_SIZE = 1;

export const defaultFlashdealRequest: Search.ZooverCompositeSearchBody = {
	...defaultBodySearchRequest,
	page_size: DEFAULT_DEALS_PAGE_SIZE,
	filters: { durations_flight: [5, 6, 7, 8, 9] },
};

export const flashDealsRequestWithPageHighlight: Search.ZooverCompositeSearchBody = {
	...defaultBodySearchRequest,
	page_size: DEFAULT_DEALS_PAGE_SIZE,
	filters: { durations_flight: [5, 6, 7, 8, 9] },
	page_highlight: 'HOMEPAGE',
};
